export const iconFontAwesomeTravelHotelShip = (
	<i className="fa-solid fa-ship"></i>
);
